// Импорты
import React, { useState } from 'react';
import './Shop.css';

// Основной компонент магазина
const Shop = () => {
  // Состояния компонента
  const [sortBy, setSortBy] = useState('name'); // Сортировка товаров
  const [selectedProduct, setSelectedProduct] = useState(null); // Выбранный товар для модального окна

  // Массив товаров с полной информацией
  const products = [
    {
      id: 1,
      name: 'Набір для догляду за волоссям',
      description: 'Інтенсивне відновлення пошкодженого волосся з кератином',
      fullDescription: 'Набір Monxuan для догляду за волоссям, підходить для всіх типів волосся, захищає колір волосся та забезпечує інтенсивне зволоження. Формули, збагачені рослинними екстрактами, перетворюють тонке та тьмяне волосся, повертаючи йому еластичність і блиск.',
    image: 'https://monxuan.ro/wp-content/uploads/2023/12/SamponMFamily-Medium.jpg',
      
      inStock: true,
      features: ['Відновлює структуру волосся', 'Насичує кератином', 'Без сульфатів', 'Для всіх типів волосся'],
      usage: 'Нанесіть невелику кількість на вологе волосся, збийте піну, ретельно змийте. Використовуйте разом з маскою для найкращого результату.'
    },
    {
      id: 2,
      name: 'Маска для дуже сухого та пошкодженого волосся, 260 мл ',
      description: 'Інтенсивне відновлення пошкодженого волосся з кератином',
      fullDescription: 'Відкрийте секрет здорового волосся з маскою Monxuan, унікальною формулою, яка відновлює та повертає красу волосся всього за 5-10 хвилин! Завдяки запатентованій технології формула маски для волосся Monxuan діє швидко, надаючи волоссю всі необхідні інгредієнти, щоб воно стало міцним, гладким та інтенсивно зволоженим. Маска для волосся Monxuan не містить агресивних хімічних речовин, і волосся повністю безпечне під час усього лікування. А отримані результати зберігаються надовго!',
      image: 'https://monxuan.ro/wp-content/uploads/2023/10/MaskM.jpg',
      
      inStock: true,
      features: ['Відновлює структуру волосся', 'Насичує кератином', 'Без сульфатів', 'Для всіх типів волосся'],
      usage: 'Нанесіть невелику кількість на вологе волосся, збийте піну, ретельно змийте. Використовуйте разом з маскою для найкращого результату.'
    },
    {
      id: 3,
      name: 'Шампунь для пошкодженого волосся, 380 мл',
      description: 'Інтенсивне відновлення пошкодженого волосся з кератином',
      fullDescription: 'Відкрийте секрет ідеального волосся з шампунем Monxuan, унікальною формулою, що відновлює та повертає здоровя пошкодженим волоссям без використання агресивних хімічних речовин, даруючи вашому волоссю справжнє та тривале перетворення.',
      image: 'https://monxuan.ro/wp-content/uploads/2023/10/SamponM.jpg',
      
      inStock: true,
      features: ['Відновлює структуру волосся', 'Насичує кератином', 'Без сульфатів', 'Для всіх типів волосся'],
      usage: 'Нанесіть невелику кількість на вологе волосся, збийте піну, ретельно змийте. Використовуйте разом з маскою для найкращого результату.'
    },
    {
      id: 4,
      name: 'Спрей для пошкодженого волосся leave-in Monxuan, 200 мл',
      description: 'Інтенсивне відновлення пошкодженого волосся з кератином',
      fullDescription: '– Підходить для всіх типів волосся –MONXUAN Elixir – інтенсивний зволожуючий догляд для волосся, який миттєво перетворює тьмяне, сухе та зневоднене волосся на шовк.– Підходить для всіх типів волосся –',
      image: 'https://monxuan.ro/wp-content/uploads/2023/10/maasca-pentru-par.jpg',
      
      inStock: true,
      features: ['Відновлює структуру волосся', 'Насичує кератином', 'Без сульфатів', 'Для всіх типів волосся'],
      usage: 'Нанесіть невелику кількість на вологе волосся, збийте піну, ретельно змийте. Використовуйте разом з маскою для найкращого результату.'
    },
    {
      id: 5,
      name: 'Шампунь для пошкодженого волосся, 720 мл',
      description: 'Інтенсивне відновлення пошкодженого волосся з кератином',
      fullDescription: 'Цей шампунь інтенсивно відновлює пошкоджене волосся завдяки унікальній формулі з кератином, біотином та натуральними оліями. Відновлює структуру волосся, заповнюючи пошкодження, надає волоссю здорового блиску та міцності. Ідеально підходить для фарбованого та ослабленого волосся.',
      image: 'https://monxuan.ro/wp-content/uploads/2025/02/HairSingle.jpg',
      
      inStock: true,
      features: ['Відновлює структуру волосся', 'Насичує кератином', 'Без сульфатів', 'Для всіх типів волосся'],
      usage: 'Нанесіть невелику кількість на вологе волосся, збийте піну, ретельно змийте. Використовуйте разом з маскою для найкращого результату.'
    },
    {
      id: 6,
      name: 'Набір для догляду за волоссям Monxuan L',
      description: 'Інтенсивне відновлення пошкодженого волосся з кератином',
      fullDescription: 'Набір для догляду за волоссям Monxuan, підходить для всіх типів волосся, захищає колір волосся та надає йому інтенсивне зволоження. Формули, збагачені рослинними екстрактами, перетворюють тонке та тьмяне волосся, повертаючи йому еластичність і блиск',
      image: 'https://monxuan.ro/wp-content/uploads/2025/05/21-1.jpg',
      
      inStock: true,
      features: ['Відновлює структуру волосся', 'Насичує кератином', 'Без сульфатів', 'Для всіх типів волосся'],
      usage: 'Нанесіть невелику кількість на вологе волосся, збийте піну, ретельно змийте. Використовуйте разом з маскою для найкращого результату.'
    },
    {
      id: 7,
      name: 'Маска для дуже сухого та пошкодженого волосся, 720 мл',
      description: 'Інтенсивне відновлення пошкодженого волосся з кератином',
      image: 'https://monxuan.ro/wp-content/uploads/2025/02/Balsamsingle.jpg',
      
      inStock: true,
      features: ['Відновлює структуру волосся', 'Насичує кератином', 'Без сульфатів', 'Для всіх типів волосся'],
      usage: 'Нанесіть невелику кількість на вологе волосся, збийте піну, ретельно змийте. Використовуйте разом з маскою для найкращого результату.'
    },
  ];

  // Функция фильтрации и сортировки товаров
  const filteredProducts = products.sort((a, b) => {
    switch (sortBy) {
      case 'price-low':
        return a.price - b.price; // Сортировка по цене (возрастание)
      case 'price-high':
        return b.price - a.price; // Сортировка по цене (убывание)
      case 'name':
      default:
        return a.name.localeCompare(b.name); // Сортировка по названию
    }
  });

  // Функция расчета процента скидки
  const getDiscountPercent = (price, originalPrice) => {
    return Math.round(((originalPrice - price) / originalPrice) * 100);
  };

  // Функции управления модальным окном
  const openProductModal = (product) => {
    setSelectedProduct(product); // Открыть модальное окно с товаром
  };

  const closeProductModal = () => {
    setSelectedProduct(null); // Закрыть модальное окно
  };

  // Рендер компонента
  return (
    <section className="shop" id="shop">
      <div className="container">
        {/* Заголовок секции */}
        <div className="shop-header">
          <h2 className="section-title">Магазин</h2>
          <p className="section-subtitle">
            Вся наша продукція для догляду за волоссям
          </p>
        </div>

        <div className="shop-content">
          {/* Основная область магазина */}
          <div className="shop-main">
            {/* Панель инструментов (сортировка, количество) */}
            {/* <div className="shop-toolbar">
              <div className="products-count">
                Знайдено {filteredProducts.length} товарів
              </div>
              <div className="sort-options">
                <label>Сортувати за:</label>
                <select 
                  value={sortBy} 
                  onChange={(e) => setSortBy(e.target.value)}
                  className="sort-select"
                >
                  <option value="name">Назвою</option>
                  <option value="price-low">Ціною (від низької)</option>
                  <option value="price-high">Ціною (від високої)</option>
                </select>
              </div>
            </div> */}

            {/* Сетка товаров */}
            <div className="products-grid">
              {filteredProducts.map(product => (
                <div 
                  key={product.id} 
                  className="product-card"
                  onClick={() => openProductModal(product)} // Клик по карточке открывает модальное окно
                >
                  {/* Изображение товара */}
                  <div className="product-image">
                    <img src={product.image} alt={product.name} />
                    {/* Бейдж товара */}
                    {product.badge && (
                      <span className={`product-badge ${product.badge.includes('%') ? 'discount' : ''}`}>
                        {product.badge}
                      </span>
                    )}
                    {/* Сообщение о отсутствии товара */}
                    {!product.inStock && (
                      <div className="out-of-stock">Немає в наявності</div>
                    )}
                  </div>

                  {/* Информация о товаре */}
                  <div className="product-info">
                    <h3 className="product-title">{product.name}</h3>
                    <p className="product-description">{product.description}</p>
                    
                    {/* Цена товара
                    <div className="product-price">
                      {product.originalPrice > product.price ? (
                        // Цена со скидкой
                        <>
                          <span className="current-price">{product.price}</span>
                          <span className="original-price">{product.originalPrice}</span>
                          <span className="discount-percent">
                            -{getDiscountPercent(product.price, product.originalPrice)}%
                          </span>
                        </>
                      ) : (
                        // Обычная цена
                        <span className="current-price">{product.price} </span>
                      )}
                    </div> */}

                    {/* Кнопка для просмотра деталей */}
                    <div className="product-view-btn">
                      Детальніше →
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Модальное окно товара */}
        {selectedProduct && (
          <div className="product-modal-overlay" onClick={closeProductModal}>
            <div className="product-modal" onClick={(e) => e.stopPropagation()}>
              {/* Кнопка закрытия */}
              <button className="modal-close-btn" onClick={closeProductModal}>×</button>
              
              {/* Контент модального окна */}
              <div className="modal-content">
                {/* Изображение товара */}
                <div className="modal-image">
                  <img src={selectedProduct.image} alt={selectedProduct.name} />
                  {selectedProduct.badge && (
                    <span className={`product-badge ${selectedProduct.badge.includes('%') ? 'discount' : ''}`}>
                      {selectedProduct.badge}
                    </span>
                  )}
                </div>

                {/* Информация о товаре */}
                <div className="modal-info">
                  <h2>{selectedProduct.name}</h2>
                  <p className="modal-description">{selectedProduct.fullDescription}</p>
                  
                  {/* Цена в модальном окне
                  <div className="modal-price">
                    {selectedProduct.originalPrice > selectedProduct.price ? (
                      <>
                        <span className="current-price">{selectedProduct.price} грн</span>
                        <span className="original-price">{selectedProduct.originalPrice} грн</span>
                        <span className="discount-percent">
                          -{getDiscountPercent(selectedProduct.price, selectedProduct.originalPrice)}%
                        </span>
                      </>
                    ) : (
                      <span className="current-price">{selectedProduct.price} грн</span>
                    )}
                  </div> */}

                  {/* Особенности товара */}
                  <div className="product-features">
                    <h3>Особливості:</h3>
                    <ul>
                      {selectedProduct.features.map((feature, index) => (
                        <li key={index}>✓ {feature}</li>
                      ))}
                    </ul>
                  </div>

                  {/* Способ применения */}
                  <div className="product-usage">
                    <h3>Спосіб застосування:</h3>
                    <p>{selectedProduct.usage}</p>
                  </div>

                  {/* Кнопки действий */}
                  <div className="modal-actions">
                    <button className="contact-btn" onClick={() => {
                      closeProductModal();
                      document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
                    }}>
                      Замовити
                    </button>
                    <button className="close-btn" onClick={closeProductModal}>
                      Закрити
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

// Экспорт компонента
export default Shop;